module.exports = __webpack_public_path__ + "img/close.89494158.png";